import "@37signals/lexxy"
import "@mantine/dates/styles.css"
import { createInertiaApp } from "@inertiajs/react"
import * as ActiveStorage from "@rails/activestorage"
import AppShell from "../components/AppShell"

ActiveStorage.start()

function DefaultLayout({ children }) {
  return <AppShell>{children}</AppShell>
}

createInertiaApp({
  pages: "../pages",
  layout: () => DefaultLayout,
  strictMode: true,
  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: "brackets" }
    },
  },
})
